module.exports = __webpack_public_path__ + "static/media/application.7b49e14e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/application.svg
// module id = 584
// module chunks = 0